import { Component, inject } from '@angular/core';

import { NetworkStatusService } from '../../../services/network-status.service';

@Component({
  selector: 'app-network-status-banner',
  standalone: true,
  imports: [],
  template: `
    @if (!networkStatus.isOnline()) {
      <div class="offline-banner">
        <span>⚠️ Nincs internetkapcsolat</span>
      </div>
    }
  `,
  styles: [`
    .offline-banner {
      position: fixed;
      top: 64px; /* AppBar magassága alatt */
      left: 0;
      right: 0;
      background: #f44336;
      color: white;
      padding: 8px;
      text-align: center;
      z-index: 9999;
      font-weight: 500;
    }
  `]
})
export class NetworkStatusBannerComponent {
  networkStatus = inject(NetworkStatusService);
}
